// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import GRRulesSvgAsComponent from '../../assets/svg/GRRulesSvgAsComponent';
import SharedStyle from '../../styled-component/shared';

const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: 9em;
  height: 3em;

  display: flex;
  align-items: center;

  ${SharedStyle.ImageAsButtonsBehaviour}
`;

const Label = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-left: -0.75em;
`;

const Background = styled(GRRulesSvgAsComponent)`
  position: absolute;
  width: 100%;
  z-index: -1;
`;

type GRRulesButtonProps = {
  onClick: () => void;
  className?: string;
};

const GRRulesButton = ({ onClick = () => {}, className = '' }: GRRulesButtonProps) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <Background />
      <Label>{__('!noun:Rules')}</Label>
    </Wrapper>
  );
};

export default GRRulesButton;
